import { Citizenship } from 'shell/models/person/citizenship';
import { SubjectAttributes } from 'shell/models/person/subject-attributes';
import { Generality } from 'shell/models/person/generality';
import { CompleteSubjectLink } from 'shell/models/person/complete-subject-link';
import {
  ControlData,
  RequestSubscriptionBirth,
} from 'subscription/models/request-subscription-birth';
import {
  transformAllegati,
  transformDatiControlloAire,
  transformGeneralita1001,
  transformLegameSoggetto,
  transformMaternita,
  transformResidenzaEstera,
  transformerPaternita,
} from './common-request-transformer';
import { transformerAttoNascitaFamily } from './birthday-document.transformer';
import { SubscriptionTranscriptionBirthActFormVM } from 'subscription/view-models/subscription-transcription-birth-act';

/**
 * Transforms a SubscriptionTranscriptionBirthActFormVM into a RequestSubscriptionBirth object.
 * @param {SubscriptionTranscriptionBirthActFormVM} values
 * @returns {RequestSubscriptionBirth}
 */
export const transformerRequestSubscriptionTranscriptionBirthActAireSoloData = (
  values: SubscriptionTranscriptionBirthActFormVM
): RequestSubscriptionBirth => {
  const attoNascita = transformerAttoNascitaFamily(values.birthdayDocument);

  const hasCitizenship =
    !!values.citizenship?.state || !!values.citizenship?.note || !!values.citizenship?.validity;

  const altraCittadinanza: Array<Citizenship> | undefined = hasCitizenship
    ? [
        {
          codiceStato: values.citizenship?.state?.id || undefined,
          dataValidita: values.citizenship?.validity
            ? values.citizenship?.validity?.toFormat('yyyy-MM-dd')
            : undefined,
          descrizioneStato: values.citizenship?.state?.value || undefined,
          noteStato: values.citizenship?.note || undefined,
        },
      ]
    : undefined;

  const paternita = transformerPaternita(values.fatherhood);

  const maternita = transformMaternita(values.motherhood);

  const legameSoggetto: CompleteSubjectLink = transformLegameSoggetto(values.familyCoexistence);

  const datiControllo: ControlData = transformDatiControlloAire(values.editDataControl);

  const generalitaA001: { attributiSoggetto?: SubjectAttributes; generalita: Generality } =
    transformGeneralita1001(values.generality, undefined);

  const residenzaEstera = transformResidenzaEstera(values.addressForeign);

  const allegati = transformAllegati(values.document);

  return {
    testataRichiesta: {
      dataDecorrenza: values.editDataControl?.dateValidity
        ? values.editDataControl?.dateValidity?.toFormat('yyyy-MM-dd')
        : undefined,
    },
    attoNascitaANPR: attoNascita || undefined,
    altraCittadinanza,
    paternita,
    maternita,
    legameSoggetto,
    datiControllo,
    generalitaA001,
    residenzaEstera,
    allegati,
  };
};
